import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon from '~/components/Icon';

function getOrderIconName(orderDirection) {
  if (orderDirection === 'asc') return 'caret-sort-up';
  if (orderDirection === 'desc') return 'caret-sort-down';
  return 'caret-sort';
}

const IconWithCursor = styled(Icon)`
  cursor: var(--cursor-button);
`;

function OrderIcon({ orderDirection }) {
  return (
    <IconWithCursor
      name={getOrderIconName(orderDirection)}
      width={16}
      height={16}
      color={undefined}
      inline
    />
  );
}

OrderIcon.propTypes = {
  orderDirection: PropTypes.oneOf(['asc', 'desc']),
};

export default OrderIcon;
